var _metadata, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2433 4582 c-28 -10 -69 -30 -90 -44 -71 -47 -2330 -1935 -2336 -1952 -13 -32 -7 -91 10 -116 9 -14 62 -78 116 -143 111 -131 125 -139 203 -122 12 3 516 417 1120 920 604 503 1101 915 1104 915 3 0 502 -414 1109 -919 839 -699 1110 -920 1134 -924 18 -2 44 0 59 5 23 8 189 193 241 268 23 33 22 101 -2 131 -11 13 -175 152 -365 309 l-345 285 -1 668 0 669 -29 29 -29 29 -347 0 c-381 0 -383 0 -404 -62 -7 -20 -11 -145 -11 -339 l0 -309 -396 331 c-273 228 -414 339 -453 357 -75 35 -211 42 -288 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643 3027 l-913 -752 0 -800 0 -801 23 -44 c13 -26 40 -57 65 -75 l44 -30 649 -3 649 -2 0 610 0 610 400 0 400 0 0 -610 0 -610 649 2 649 3 44 30 c23 17 53 49 65 70 l23 40 0 805 0 805 -910 750 c-501 413 -914 751 -918 752 -4 2 -418 -336 -919 -750z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.45131bf1.svg";
export { ForwardRef as ReactComponent };